const NotFound = () => {
    return(
        <div className="text-center text-3xl text-red-500 font-bold">Page not Found</div>
    );
};

export default NotFound;